import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Button, MenuItem, TextField } from "@mui/material";
import GoalVideoComponent from "./GoalVideoComponent";
import Position from "./leaderboardBanner/Position";
import { styled } from "@mui/material";
import moment from "moment";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";
import { useSelector } from "react-redux";

const CustomTextarea = styled(TextField)(() => ({
  flexGrow: "1",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    color: "#6f7081",
    padding: "0px 0px 0px 30px;",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiSelect-icon": {
    color: "#6f7081 !important",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const Leaderboard = ({
  goals,
  setTournamentData,
  league_logo,
  fetchLeaderboard,
  leagueData,
}) => {
  const token = useSelector((state) => state.auth.token);
  const [filter, setFilter] = useState("yearly");
  const [month, setMonth] = useState(leagueData?.leagueEvents[0]?.id);
  const [year, setYear] = useState(new Date().getFullYear());

  useSkipFirstRender(() => {
    if (filter == "monthly") {
      if (!month) return;
      else fetchLeaderboard(leagueData.id, token, { year: null, month: month });
    } else if (filter == "yearly") {
      fetchLeaderboard(leagueData.id, token, { year: year, month: null });
    } else {
    }
  }, [filter]);

  useSkipFirstRender(() => {
    fetchLeaderboard(leagueData.id, token, { year: year, month: null });
  }, [year]);

  useSkipFirstRender(() => {
    if (month) {
      fetchLeaderboard(leagueData.id, token, { year: null, month: month });
    } else {
      return;
    }
  }, [month]);
  return (
    <>
      <Box className={"filters"}>
        <Button
          className={filter == "monthly" ? "filter_item active" : "filter_item"}
          onClick={() => setFilter("monthly")}
        >
          Monthly
        </Button>
        <Button
          className={filter == "yearly" ? "filter_item active" : "filter_item"}
          onClick={() => setFilter("yearly")}
        >
          Seasons
        </Button>
      </Box>

      <Box
        className="Category-filter-wrapper"
        sx={{
          justifyContent: "space-between",
          minHeight: "70px",
          borderBottom: "1px solid #414466;",
        }}
      >
        {filter == "yearly" ? (
          <CustomTextarea
            select
            variant="outlined"
            name="previous_months"
            value={year}
            onChange={(e) => {
              setYear(e.target.value);
            }}
            sx={{
              maxWidth: "200px",
              border: "1px solid #414466",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            <MenuItem value="default">Select Year</MenuItem>
            {Array.from({ length: 6 }).map((_, i) => (
              <MenuItem
                value={moment(leagueData.createdAt)
                  .add(i, "years")
                  .format("YYYY")}
              >
                {moment(leagueData.createdAt).add(i, "years").format("YYYY")}
              </MenuItem>
            ))}
          </CustomTextarea>
        ) : (
          <CustomTextarea
            select
            variant="outlined"
            name="previous_months"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
            }}
            sx={{
              maxWidth: "200px",
              border: "1px solid #414466",
              borderRadius: "8px",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            <MenuItem value="default">Select Months</MenuItem>

            {leagueData?.leagueEvents?.length > 0 ? (
              leagueData?.leagueEvents?.map((obj) => (
                <MenuItem value={obj.id}>{obj.name}</MenuItem>
              ))
            ) : (
              <MenuItem>No club month found</MenuItem>
            )}
          </CustomTextarea>
        )}
      </Box>

      <Box
        sx={{
          padding: { md: "20px 30px", xs: "10px" },
          borderTop: "1px solid #414466",
        }}
        className="leaderboard-data-wrapper"
      >
        <Typography
          component="h1"
          sx={{
            color: "white",
            fontSize: "20px",
            fontWeight: "bold",
            margin: "15px 0",
          }}
        >
          Leaderboard
        </Typography>

        {goals?.length > 0 ? (
          <Box className="leaderboard-banner-wrapper">
            <Box className="background">
              <Typography component={"span"} className="heading_text">
                TOP LEADERBOARD OF THE MONTH
              </Typography>
              <Box className="position-wrapper">
                <Position
                  index={0}
                  leaderboard={goals}
                  club_logo={league_logo}
                />
                {goals?.length > 1 && (
                  <Position
                    index={1}
                    leaderboard={goals}
                    club_logo={league_logo}
                  />
                )}
                {goals?.length > 2 && (
                  <Position
                    index={2}
                    leaderboard={goals}
                    club_logo={league_logo}
                  />
                )}
              </Box>
            </Box>
          </Box>
        ) : null}

        {Array.isArray(goals) && goals.length > 0 ? (
          <>
            <Box className="rank-logo">Rank</Box>
            {goals.map((ele, index) => {
              if (index == goals.length - 1) {
                return (
                  <>
                    <GoalVideoComponent
                      key={index}
                      data={ele}
                      setTournamentData={setTournamentData}
                      index={index}
                    />
                  </>
                );
              } else {
                return (
                  <>
                    <GoalVideoComponent
                      key={index}
                      data={ele}
                      setTournamentData={setTournamentData}
                      index={index}
                    />
                  </>
                );
              }
            })}
          </>
        ) : (
          <Box className="no-data-found">No Data Found</Box>
        )}
      </Box>
    </>
  );
};

export default Leaderboard;
